/** @prettier */

import {Box, Grid, Button, Menu, MenuItem} from '@mui/material';
import {Link, useNavigate} from 'react-router-dom';
import {useState} from 'react';

//Style import
import '../css/common/common.css';

import {routeList} from './PrivateRoute';
import {file, iconBlack} from '../define';

/**
 * ログイン前のヘッダー
 * @returns JSX
 */
const Header = () => {
  const navigate = useNavigate();

  //ヘルプメニュー
  const [helpMenu, setHelpMenu] = useState<null | HTMLElement>(null);
  const helpMenuOpen = Boolean(helpMenu);

  /**
   * HELPメニューを開いた時の処理
   * @param event
   */
  const helpClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setHelpMenu(event.currentTarget);
  };

  /**
   * HELPメニューを閉じたときの処理
   */
  const helpClose = () => {
    setHelpMenu(null);
  };

  return (
    <Grid
      container
      columnSpacing={3}
      justifyContent="space-between"
      alignItems="center">
      {/* M-ACCESSのロゴ */}
      <Grid item xs="auto" className="logoBox">
        <img
          className="logoBox__icon--m-access"
          src={file.MACCESS_LOGO_PATH}
          alt="m_access_logo"
        />
      </Grid>
      {/* LOGIN */}
      <Grid item xs>
        <Link
          to={routeList.login.path}
          id="mv-linkMainHeaderLoginTxt"
          className="login">
          <Box id="mv-linkMainHeaderLoginBox" className="login__text">
            LOGIN
          </Box>
        </Link>
      </Grid>
      {/* HELP */}
      <Grid item xs="auto">
        <Button
          id="mv-mainHeaderHelpBox"
          color="secondary"
          className="help"
          aria-controls={helpMenuOpen ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          aria-expanded={helpMenuOpen ? 'true' : undefined}
          onClick={helpClick}
          endIcon={
            <img
              className="help__icon"
              src={iconBlack.CHEVRON_DOWN.src}
              alt={iconBlack.CHEVRON_DOWN.alt}
            />
          }>
          HELP
        </Button>
        {/* ヘルプメニューリスト */}
        <Menu
          id="mv-mainHeaderHelpMenuList"
          anchorEl={helpMenu}
          open={helpMenuOpen}
          onClose={helpClose}>
          <MenuItem
            id="mv-linkTermsOfService"
            onClick={() => {
              navigate(routeList.termsOfService.path);
              helpClose();
            }}>
            User terms
          </MenuItem>
          <MenuItem
            id="mv-linkPrivacyPolicy"
            onClick={() => {
              navigate(routeList.privacyPolicy.path);
              helpClose();
            }}>
            Privacy policy
          </MenuItem>
        </Menu>
      </Grid>
      {/* MHIのロゴ */}
      <Grid item xs="auto" className="logoBox">
        <img
          className="logoBox__icon--mhi"
          src={file.MHI_LOGO_PATH}
          alt="mhi_logo"
        />
      </Grid>
    </Grid>
  );
};
export default Header;
